module.exports = __webpack_public_path__ + "img/umkm-go-online.c2f3082c.jpg";